// DinamicX
import { createElement } from "rax";
import * as Dinamic from "@ali/dinamic";
import { ImageView } from "@ali/dinamic-views-icbu-fork";
import { isRTL } from "../utils"
import {setIndexMapContext} from '../utils/index';

// 基于 ImageView 扩展
// rtlAutoFlip: RTL 语种时自动翻转
class ALIImageView extends ImageView {
  rtlAutoFlip(propValue) {
    if (propValue === "true" && isRTL()) {
      this.setStyles({ transform: "rotate(180deg)" });
    }
  }
  renderView() {
    let { imgSrc } = this.imageData || {};
    // 这里会对宽高均适配父层的情况做特殊处理，走loaderror的方式再次
    let { width, height, htmlAlt, aspectRatio} = this.props;
    // 要注意处理解析表达式结果为 'undefined' 的情况
    if (imgSrc && imgSrc !== 'undefined') {
      
      // const maskBgColor = `rgba(0,0,0,${darkModeOverlayOpacity||'0.02'})`;
      const wrapstyle = this.getStyles('img');
      const placeholderStyle = {
        opacity:0,
        maxWidth: '100%',
        maxHeight: '100%'
      }
      

      if(Number(width) && Number(height)) {
        return (
          <img
            onLoad={() => this.dynamicImageLoaded()}
            onError={() => this.dynamicImageLoadError()}
            // 使用data-src, 会导致 alt显示错误， 暂时去掉懒加载
            src={imgSrc}
            ref={$img => (this.$img = $img)}
            alt={htmlAlt ? htmlAlt:null}
            style={{
              width:  width+"px",
            }}
          />
        )
      }



      // let ratioHeight; // 默认是占位高度，适应于无限加载场景的时默认图占位，防止页面抖动
      // if ( aspectRatio && this.aspectRatioValue > 0) {
      //   ratioHeight = ( 100 / this.aspectRatioValue ) + '%';
      // }
      // if (wrapstyle.width.indexOf('px') > 0) {
      //   placeholderStyle.width = wrapstyle.width;
      // } else {
      //   placeholderStyle.width = '100%';
      // }
      // if (wrapstyle.height.indexOf('px') > 0) {
      //   placeholderStyle.height = wrapstyle.height;
      // }
      // if (ratioHeight) {
      //   placeholderStyle.height = 0;
      //   placeholderStyle.paddingTop = ratioHeight;
        
      //   wrapstyle.height = "";
      // } else if(!placeholderStyle.height){
      //   placeholderStyle.maxHeight = '100%';
      // }

      return (
        <div  ref={$wrap => (this.$wrap = $wrap)} style={{
          ...wrapstyle,
          }}>
          <img
            onLoad={() => this.dynamicImageLoaded()}
            onError={() => this.dynamicImageLoadError()}
            // 使用data-src, 会导致 alt显示错误， 暂时去掉懒加载
            src={imgSrc}
            ref={$img => (this.$img = $img)}
            alt={htmlAlt ? htmlAlt:null}
            style={{
              ...placeholderStyle
            }}
          />
        </div>
      );
    }

    return <div style={this.getStyles('img')} />;
  }
  render() { 
    const props = this.props;
    // 渲染前绑定上下文，使所有控件均可在渲染结束后调用 calc
    setIndexMapContext.call(this);
    let { width, height, htmlAlt, aspectRatio, } = this.props;
    const sty = this.getStyles();
    
    return (
      <div
        ref={$wrap => (this.$__DXWrap = $wrap)}
        key={props._id}
        view-name={this.getViewName()}
        style={sty}
        {...this.getAttrs()}
      >
        {props.visibility !== 'gone' && this.renderView && this.renderView(props)}
      </div>
    );
  }
}

Dinamic.registerView("ALIImageView", ALIImageView);

export default ALIImageView;



